import React, { useEffect, useState } from 'react';
import Button from '../../../../../shared/components/Button/Button';
import Input from '../../../../../shared/components/Input/Input';
import Dialog from '../../../../../shared/components/Dialog/Dialog';

const isValidImageUrl = (value = '') => /^https?:\/\//i.test(value.trim());

function WikiImageDialog({ open, onClose, onSubmit }) {
  const [draft, setDraft] = useState({ src: '', alt: '', title: '' });
  const [previewError, setPreviewError] = useState(false);
  const hasError = Boolean(draft.src.trim()) && !isValidImageUrl(draft.src);

  useEffect(() => {
    if (open) {
      setDraft({ src: '', alt: '', title: '' });
      setPreviewError(false);
    }
  }, [open]);

  const updateDraft = (field, value) => {
    setDraft((current) => ({ ...current, [field]: value }));
    if (field === 'src') {
      setPreviewError(false);
    }
  };

  const submit = () => {
    onSubmit({
      src: draft.src.trim(),
      alt: draft.alt.trim(),
      title: draft.title.trim(),
    });
    setDraft({ src: '', alt: '', title: '' });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Image par URL"
      actions={(
        <>
          <Button variant="tertiary" onClick={onClose}>Annuler</Button>
          <Button variant="primary" disabled={!draft.src.trim() || hasError} onClick={submit}>
            Inserer
          </Button>
        </>
      )}
    >
        <Input
          autoFocus
          fullWidth
          label="URL de l'image"
          value={draft.src}
          aria-invalid={hasError}
          onChange={(event) => updateDraft('src', event.target.value)}
        />
        <small className={hasError ? 'wiki-dialog-help error' : 'wiki-dialog-help'}>
          {hasError ? 'Les images doivent utiliser une URL http(s).' : 'Les images ne sont pas stockées en base64. Une selection GED pourra être ajoutée ici.'}
        </small>
        {draft.src && !hasError && !previewError && (
          <img
            className="wiki-image-preview"
            src={draft.src}
            alt={draft.alt || 'Apercu'}
            onError={() => setPreviewError(true)}
          />
        )}
        {previewError && (
          <small className="wiki-dialog-help error">
            L'aperçu n'a pas pu être chargé. Vérifiez l'URL ou les droits d'accès.
          </small>
        )}
        <Input
          fullWidth
          label="Texte alternatif"
          value={draft.alt}
          onChange={(event) => updateDraft('alt', event.target.value)}
        />
        <Input
          fullWidth
          label="Titre facultatif"
          value={draft.title}
          onChange={(event) => updateDraft('title', event.target.value)}
        />
    </Dialog>
  );
}

export default WikiImageDialog;
